import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { DynamicFlowOption } from '../../model/dynamic-flow.types';

@Component({
  selector: 'c-single-select',
  imports: [],
  templateUrl: './single-select.component.html',
  styleUrl: './single-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleSelectComponent {
  @Input() label: string;
  @Input() description: string;
  @Input() options: DynamicFlowOption[];
  @Input() selectedOption: DynamicFlowOption;
  @Output() select = new EventEmitter<DynamicFlowOption>();

  selectOption(option: DynamicFlowOption): void {
    this.select.emit(option);
  }
}
